import { Box } from "@mui/material";
import React from "react";
import { QuotationFormValues } from "../../../types";
import {
  QUOTATION_BASE_COSTS_FIELDS,
  QUOTATION_PARAMETERS_FIELDS,
  QUOTATION_PRICING_FIELDS,
  QUOTATION_SECTION_KEYS,
} from "../data";
import QuotationSection from "./QuotationSection";
import { useStyles } from "./styles";

type Props = {
  formValues: QuotationFormValues;
};

const QuotationFormPanel = ({ formValues }: Props) => {
  const styles = useStyles();

  return (
    <Box className={styles.sectionsCard}>
      <QuotationSection
        titleKey={QUOTATION_SECTION_KEYS.BASE_COSTS}
        fields={QUOTATION_BASE_COSTS_FIELDS}
        formValues={formValues}
        hideTopBorder
      />

      <QuotationSection
        titleKey={QUOTATION_SECTION_KEYS.PARAMETERS}
        fields={QUOTATION_PARAMETERS_FIELDS}
        formValues={formValues}
      />

      <QuotationSection
        titleKey={QUOTATION_SECTION_KEYS.PRICING}
        fields={QUOTATION_PRICING_FIELDS}
        formValues={formValues}
        columns={3}
      />
    </Box>
  );
};

export default QuotationFormPanel;
